const TaskExternalOrderProcessingMode = {
    PROCESS_TOGETHER: "PROCESS_TOGETHER",
    PROCESS_AVAILABLE: "PROCESS_AVAILABLE",
    DO_NOT_PROCESS: "DO_NOT_PROCESS"
};

export {TaskExternalOrderProcessingMode};
